import React, {useState} from "react";
import { Typography,
    Grid,
    Button,
    makeStyles,
    Container } from "@material-ui/core";
import { ReactComponent as WelcomeSVG } from "../../../Images/welcomeImage.svg";
import {useHistory } from "react-router-dom";
import { useEffect } from "react";

interface Props {
	changeCount: (number: number) => void;
}

const useStyle = makeStyles(() => ({
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
    spacingImage: {
        paddingTop: 20,
        display: "flex"
    },
}));

const Offer = ({changeCount} : Props) => {
    let history = useHistory();
    const classes=useStyle();

    useEffect(() => {
        window.scrollTo(0,0);
    }, []);

    return (
        <Container className={classes.body} disableGutters={true}>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h2">
                        Welcome to the Hello Ralphie Fam!
                    </Typography>
                </Grid>
                <Grid item xs={12} className={classes.spacingImage}>
                    <WelcomeSVG style={{width: "100%"}}/>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5" className={classes.spacing}>
                        We want to get to know you & your pet!
                    </Typography>
                </Grid>
                <Grid item xs={12} className={classes.spacing}>
                    <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        onClick={() => {
                            changeCount(1);
                        }}
                    >
                        Complete Onboarding
                    </Button>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Offer;
